import * as React from 'react';
import { SVGProps } from 'react';

const IconWatchFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0zM6 2H5v4.27l3.217 2.252.574-.82L6 5.75V2z"
    />
  </svg>
);
export default IconWatchFilledSizeXs;
